import { Component } from '@angular/core';

@Component({
    selector: 'gbc-form-hint',
    templateUrl: './form-hint.component.html',
    styleUrls: ['./form-hint.component.css'],
})
export class FormHintComponent {
  constructor() {}
}
